import axios from 'axios';

const GEOLOCATION_API = 'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation';
const LEAD_API = 'https://leadapi.crmbytes.com/api/Lead/AddLead';

// Fetch geolocation data
export const getGeoLocation = async () => {
  try {
    const response = await axios.get(GEOLOCATION_API);
    if (response.data.isSuccess) {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error('Geolocation API error:', error);
    return null;
  }
};

// Submit lead to CRM
export const submitLead = async (formData, geoLocationData, packageInfo = null) => {
  try {
    const payload = {
      name: formData.name,
      email: formData.email,
      countryDialCode: parseInt(formData.countryCode.replace('+', '')),
      country: formData.country || (geoLocationData?.countryCode || ''),
      phoneNumber: formData.phone, // Only numeric, no country code
      ipAddress: geoLocationData?.ipAddress || '',
      description: formData.message || '',
      pageUrl: window.location.href,
      city: geoLocationData?.cityName || '',
      state: geoLocationData?.regionName || '',
      geoLocation: geoLocationData ? JSON.stringify({
        isSuccess: true,
        data: geoLocationData,
        errorMessage: '',
        statusCode: 200
      }) : '',
      packageTitle: packageInfo?.title || '',
      packageAmount: packageInfo?.amount || 0
    };

    const response = await axios.post(LEAD_API, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return {
      success: true,
      data: response.data,
      statusCode: response.data.statusCode
    };
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        statusCode: error.response.data.statusCode || error.response.status,
        message: error.response.data.message || error.response.data.errorMessage || 'An error occurred',
        data: error.response.data
      };
    }
    return {
      success: false,
      statusCode: 500,
      message: 'Network error. Please try again.'
    };
  }
};

// Map country code to dial code
export const getDialCodeFromCountry = (countryCode) => {
  const countryDialCodes = {
    'US': '+1', 'CA': '+1', 'GB': '+44', 'UK': '+44', 'IN': '+91',
    'AU': '+61', 'NZ': '+64', 'JP': '+81', 'CN': '+86', 'DE': '+49',
    'FR': '+33', 'IT': '+39', 'ES': '+34', 'BR': '+55', 'MX': '+52',
    'RU': '+7', 'KR': '+82', 'SA': '+966', 'AE': '+971', 'PK': '+92',
    'NL': '+31', 'BE': '+32', 'SE': '+46', 'NO': '+47', 'DK': '+45',
    'FI': '+358', 'PL': '+48', 'TR': '+90', 'ZA': '+27', 'NG': '+234'
  };
  return countryDialCodes[countryCode] || '+1';
};
